import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Shop } from '@services/shops/shop.model';
import { TrackingPageService } from '../../../tracking-page.service';

@Component({
  selector: 'tracking-page-product-widget',
  templateUrl: './tracking-page-product-widget.component.html',
  styleUrls: ['./tracking-page-product-widget.component.scss', '../../../tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPageProductWidgetComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
  dynamicFieldsAutocompleteOptions$ = this.trackingPageService.dynamicFieldsAutocomplete$;

  entities: string[];

  constructor(private trackingPageService: TrackingPageService) {}

  ngOnInit(): void {
    this.trackingPageService.initDynamicFieldsAutocomplete();
  }

  protected readonly FormGroup = UntypedFormGroup;
}
